import styled from 'styled-components';
import AgreementRentPolicyImage from '@/assets/img/jejuro-agreement-rent.png';
import { ContentWrapper } from '@/components/reservationDetails/commonStyles';

const AgreementRentPolicy = () => {
  return (
    <ContentWrapper>
      <InnerWrapper>
        <img
          src={AgreementRentPolicyImage}
          width='100%'
          alt='렌트카 대여 표준약관'
        />
      </InnerWrapper>
    </ContentWrapper>
  );
};

export default AgreementRentPolicy;

const InnerWrapper = styled.div`
  margin-top: 60px;
`;
